import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const SSOCallback = () => {
  const { validateAndSetToken } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    if (!token) {
      setError('Token lipsă');
      return;
    }
    validateAndSetToken(token)
      .then(() => navigate('/app'))
      .catch(() => {
        setError('Token invalid');
        navigate('/login');
      });
  }, [location.search, validateAndSetToken, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="sso-callback">
      <div className="text-sm text-zinc-400">{error || 'Se autentifică...'}</div>
    </div>
  );
};

export default SSOCallback;
